import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock, Award, Download, MonitorSmartphone } from 'lucide-react';
export function ProductPresentation() {
  const benefits = [{
    icon: <Clock className="w-8 h-8 text-brand-green" data-id="element-118" />,
    title: 'Lo que antes eran 40 minutos, ahora son 5',
    desc: 'Cada plantilla está pensada para completar solo los datos variables del paciente.'
  }, {
    icon: <Award className="w-8 h-8 text-brand-green" data-id="element-119" />,
    title: 'Imagen profesional desde el día uno',
    desc: 'Documentos con estructura clínica real que generan confianza inmediata en el dueño.'
  }, {
    icon: <Download className="w-8 h-8 text-brand-green" data-id="element-120" />,
    title: 'Descargás y usás hoy',
    desc: 'Sin configurar nada. Sin cursos. Editás con tu nombre y listo.'
  }, {
    icon: <MonitorSmartphone className="w-8 h-8 text-brand-green" data-id="element-121" />,
    title: 'PDF editable y Word',
    desc: 'Compatible con cualquier dispositivo o sistema de gestión.'
  }];
  return <section className="py-12 md:py-20 px-4 max-w-5xl mx-auto" data-id="element-122">
      <FadeIn data-id="element-123">
        <div className="text-center mb-12 md:mb-16" data-id="element-124">
          <h2 className="text-4xl md:text-6xl font-black text-brand-dark mb-4" data-id="element-125">
            Consultorio en orden
          </h2>
          <p className="text-xl md:text-3xl text-brand-green font-bold" data-id="element-126">
            Kit clínico para veterinarios
          </p>
          <p className="mt-6 md:mt-8 text-lg md:text-xl text-brand-muted max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-127">
            Un sistema completo de documentación profesional, listo para usar
            desde el momento en que lo descargás. Sin crear nada desde cero. Sin
            improvisar. Sin quedarte hasta tarde escribiendo.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-128">
        {benefits.map((b, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-129">
            <div className="bg-brand-white border border-brand-border rounded-2xl p-6 md:p-10 h-full shadow-sm hover:shadow-md transition-shadow" data-id="element-130">
              <div className="bg-brand-green/10 w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-131">
                {b.icon}
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-brand-dark mb-3 md:mb-4" data-id="element-132">
                {b.title}
              </h3>
              <p className="text-brand-muted font-medium leading-relaxed md:text-lg" data-id="element-133">
                {b.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}